<template>
  <div class="replacementmonthlystatistics__report__view">
    <div class="reports__subheader">
      <year-month-panel
        @year="(value) => (year = value)"
        @month="(value) => (month = value)"
      >
      </year-month-panel>

      <employees-panel
        @employeeId="(value) => (employeeId = value)"
        :employeeNumber="employeeNumber"
        v-if="isAdmin"
      >
      </employees-panel>

      <submit-panel @submit="performLookup"> </submit-panel>

      <submit-panel
        @submit="approveAll"
        text="Godkend måned"
        v-if="monthReport && monthReport.length > 0 && hasEditRights"
      >
      </submit-panel>
    </div>

    <template>
      <div class="list-container">
        <div class="list-th">Dag</div>
        <div class="list-th">Planlagt</div>
        <div class="list-th">Opgave</div>
        <div class="list-th">Kørt for/Afløst af</div>
        <div class="list-th-number">Afholdt/optjente dage</div>
        <div class="list-th-number">Afholdt/optjente ferie dage</div>
        <div class="list-th-number">Sygedage</div>
        <div class="list-th-number">Afholdt/optjente timer</div>
        <div class="list-th-number">Time reg. heldage</div>
        <div class="list-th-number" v-if="showABK">ABK før 7:15</div>
        <div class="list-th">Time reg.</div>
        <div class="list-th">Kommentar</div>
        <div class="list-th">Kontor Kommentar</div>
        <div class="list-th" v-if="isAdmin && hasEditRights">
          Admin Kommentar
        </div>
        <div class="list-th" v-if="isAdmin && hasEditRights">Status</div>
        <div class="list-th">Handling</div>
      </div>
      <div
        v-for="row in monthReport"
        :value="row.value"
        :key="row.value"
        class="list-container"
      >
        <div class="list-td">
          <span style="float: left;" v-if="row.day !== 0">{{ row.day }}:</span>
          <span style="float: left;">{{ row.dayName }}</span>
        </div>
        <div class="list-td" :class="[colorMap(row)]">
          {{ translateAllocation(row.allocationTypePlanned) }}
        </div>
        <div class="list-td-wrap">{{ row.circleName }}</div>
        <div class="list-td">{{ row.replacement }}</div>
        <div class="list-td-number">{{ row.days | onedecimal }}</div>
        <div class="list-td-number">{{ row.vacationDays | onedecimal }}</div>
        <div class="list-td-number" :style="row.isOverlined ? {'text-decoration-line': 'line-through', 'text-decoration-color' : 'red'} : {}">{{ row.sickDays | onedecimal }}</div>
        <div class="list-td-number cell-time">{{ row.hoursAsTimeSpan }}</div>
        <div class="list-td-number cell-time">
          {{ row.timeRegDays | twodecimal }}
        </div>
        <div class="list-td-number cell-time" v-if="showABK">
          {{ row.timeInMinutesABKAsTimeSpan }}
        </div>
        <div class="list-td cell-time">{{ row.timeRegistrationType }}</div>
        <div class="list-td cell-note">{{ row.note }}</div>
        <div class="list-td cell-note">{{ row.officeNote }}</div>
        <div class="list-td cell-note" v-if="isAdmin && hasEditRights">
          {{ row.adminNote }}
        </div>
        <div class="list-td" v-if="isAdmin && hasEditRights">
          {{
            row.allocationState === 10 || row.allocationState === 30
              ? "Ok"
              : "Mangler"
          }}
        </div>
        <div class="list-td">
          <span
            v-if="
              (row.allocationState === 10 && !isAdmin) ||
                (row.allocationState === 20 && isAdmin)
            "
            >Godkendt</span
          >
          <span v-if="row.allocationState === 30">Lukket</span>
          <button
            v-if="
              ((row.allocationState === 0 || row.allocationState === 10) &&
                isAdmin) ||
                ((row.allocationState === 0 || row.allocationState === 20) &&
                  !isAdmin)
            "
            @click="approve(row.date)"
          >
            Godkend dag
          </button>
        </div>
      </div>
    </template>

    <b-loading
      :is-full-page="isFullPage"
      :active.sync="saving"
      :can-cancel="true"
    ></b-loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import APISTATE from "@/enums/APISTATE";
import SubmitPanel from "@/components/report/SubmitPanel.vue";
import YearMonthPanel from "@/components/report/YearMonthPanel.vue";
import EmployeesPanel from "@/components/report/EmployeesPanel.vue";

export default {
  name: "monthlystatistics-report-view",
  components: { SubmitPanel, YearMonthPanel, EmployeesPanel },
  props: {
    employeeNumber: {
      type: Number,
      required: undefined,
    },
  },
  data: () => ({
    year: undefined,
    month: undefined,
    employeeId: undefined,
    saving: false,
    isFullPage: true,
  }),
  async mounted() {
    await this.$store.dispatch("metadata/initialize");

    if (this.isAdmin === false) {
      this.employeeId = this.currentUser.id;
    }
  },
  methods: {
    ...mapActions("reportStore", [
      "getMonthReport",
      "approveMonthReport",
      "approveAllMonthReport",
    ]),
    async performLookup() {
      const dto = {
        year: this.year,
        month: this.month + 1,
        forUser: this.employeeId,
      };
      await this.getMonthReport(dto);
    },
    async approve(date) {
      if (this.hasEditRights === false) {
        return;
      }
      this.saving = true;
      await this.approveMonthReport({ date: date, forUser: this.employeeId });
      await this.performLookup();
      this.saving = false;
    },
    async approveAll() {
      if (this.hasEditRights === false) {
        return;
      }
      this.$buefy.dialog.alert({
        title: "Godkend måned",
        message: `Vil du godkende hele ${this.month + 1}?`,
        type: "is-success",
        canCancel: true,
        onConfirm: async () => await this.submitApproveAll(),
      });
    },
    async submitApproveAll() {
      this.saving = true;
      const dto = {
        year: this.year,
        month: this.month + 1,
        forUser: this.employeeId,
      };
      await this.approveAllMonthReport(dto);
      this.saving = false;
    },
    translateAllocation(arg) {
      if (this.allocationTypesReport) {
        let obj = this.allocationTypesReport.find((o) => o.key === arg);
        if (obj) {
          if (obj.title) {
            return obj.title;
          }
          return obj.label;
        }
        if (arg) {
          const args = arg.split(", ");
          let objs = this.allocationTypesReport.filter((o) =>
            args.includes(o.key)
          );
          let result = "";
          for (const element of objs) {
            if (objs.indexOf(element) === objs.length - 1) {
              result += element.label;
              continue;
            }
            result += element.label + ", ";
          }
          return result;
        }
      }

      if (this.allocationTypes) {
        return this.allocationTypes[arg];
      }

      return arg;
    },
    colorMap(arg) {
      const colors = [
        "orange",
        "green",
        "aqua",
        "blue",
        "purple",
        "magenta",
        "red",
        "gray",
        "black",
        "yellow",
      ];

      if (arg && arg.allocationTypePlanned) {
        if (arg.allocationTypePlanned === "OFFDAY") {
          return "yellow";
        }
        if (arg.allocationTypePlanned === "VACATION") {
          return "black";
        }
        if (arg.allocationTypePlanned.indexOf("SICKDAY") > -1) {
          return "purple";
        }
      }
      if (arg && arg.colorCode && colors.indexOf(arg.colorCode) > -1) {
        return arg.colorCode;
      }

      return "white";
    },
  },
  computed: {
    ...mapGetters("reportStore", ["monthReportApiState", "monthReport"]),
    ...mapGetters("metadata", ["allocationTypes", "allocationTypesReport"]),
    ...mapGetters(["currentUser", "isAdmin", "isReplacement", "hasEditRights"]),
    loading() {
      return this.monthReportApiState === APISTATE.LOADING;
    },
    showABK() {
      return this.isReplacement || this.isAdmin;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-container {
  display: grid;
  grid-template-columns: 55px repeat(14, 1fr) 1fr;
  grid-gap: 0px;
  border-bottom: 1px solid darkgray;
  min-height: 35px;
}

.list-th {
  font-weight: 600;
  font-size: 12px;
  padding: 3px 5px !important;
  margin: 0px !important;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
}
.list-th-number {
  font-weight: 600;
  font-size: 12px;
  padding: 3px 5px !important;
  margin: 0px !important;
  text-align: right;
}
.list-td {
  font-size: 12px;
  padding: 3px 5px !important;
  margin: 0px !important;
  text-align: left;
}
.list-td-wrap {
  font-size: 12px;
  padding: 3px 5px !important;
  margin: 0px !important;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
}
.list-td-number {
  font-size: 12px;
  padding: 3px 5px !important;
  margin: 0px !important;
  text-align: right;
}

.list-td > button {
  height: auto !important;
  padding: 3px 5px;
}

div.blue {
  background: rgba(0, 70, 150, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.orange {
  background-color: rgba(250, 100, 0, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.purple {
  background: rgba(120, 50, 140, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.magenta {
  background-color: rgba(210, 40, 100, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.red {
  background-color: rgba(210, 10, 10, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.gray {
  background-color: rgba(136, 136, 136, 0.8);
  color: black;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.black {
  background-color: rgba(34, 34, 34, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.aqua {
  background-color: rgba(60, 160, 200, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}

div.green {
  background-color: rgba(30, 140, 10, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}

div.yellow {
  background-color: rgba(246, 255, 0, 0.8);
  color: black;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}

.b-table {
  font-size: 12px;
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .list-th {
    font-weight: 600;
    font-size: 11px;
  }
  .list-th-number {
    font-weight: 600;
    font-size: 11px;
    overflow: hidden;
    white-space: nowrap;
  }
  .list-td {
    font-size: 11px;
    overflow: hidden;
    white-space: nowrap;
  }
  .list-td-wrap {
    font-size: 11px;
    overflow: hidden;
    white-space: nowrap;
  }
  .list-td-number {
    font-size: 11px;
    overflow: hidden;
    white-space: nowrap;
  }
}

@media (min-width: 230px) and (max-width: 767.98px) {
  .list-th {
    font-size: 10px;
  }
  .list-th-number {
    font-size: 10px;
    overflow: hidden;
    white-space: nowrap;
  }
  .list-td {
    font-size: 10px;
    overflow: hidden;
    white-space: nowrap;
  }
  .list-td-wrap {
    font-size: 10px;
    overflow: hidden;
    white-space: nowrap;
  }
  .list-td-number {
    font-size: 10px;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
